export const validateUrl = async (url: string): Promise<boolean> => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};
